import i18n from '@/i18n/i18n'

// 全匹
export const DESC_FULL_CONFIG = {
  '0X0102': {
    type: 1,
    title: 'uplink',
    src: require('../../assets/img/icon_type20.png'),
  },
  '0X0103': {
    type: 1,
    title: 'wifi',
    src: require('../../assets/img/icon_type21.png'),
  },
  '0X0104': {
    type: 1,
    title: 'ble',
    src: require('../../assets/img/icon_type22_2.png'),
  },
  '0X0105': {
    type: 1,
    title: 'dali',
    src: require('../../assets/img/icon_type23.png'),
  },
  '0X0106': {
    type: 1,
    title: '485',
    src: require('../../assets/img/icon_type24.png'),
  }
}

// 半匹配
export const DESC_HALF_CONFIG = {
  '0X03': {
    type: 2,
    title: i18n.t('devicecard.light'),
    src: require('../../assets/img/icon_type010.png')
  },
  '0X04': {
    type: 2,
    title: i18n.t('devicecard.colortemperature'),
    src: require('../../assets/img/icon_type11.png')
  },
  '0X06': {
    type: 2,
    title: i18n.t('devicecard.illuminance'),
    src: require('../../assets/img/icon_type07.png')
  },
  '0X07': {
    type: 2,
    title: i18n.t('devicecard.temperature'),
    src: require('../../assets/img/icon_type08.png')
  },
  '0X08': {
    type: 2,
    title: i18n.t('devicecard.humidity'),
    src: require('../../assets/img/icon_type09.png')
  },
  '0X09': {
    type: 2,
    title: i18n.t('devicecard.co2'),
    src: require('../../assets/img/icon_type12.png')
  },
  '0X0A': {
    type: 2,
    title: i18n.t('devicecard.pm'),
    src: require('../../assets/img/icon_type13.png')
  },
  '0X0B': {
    type: 3,
    title: 'tvoc',
  },
  '0X0C': {
    type: 2,
    title: i18n.t('devicecard.power'),
    src: require('../../assets/img/icon_type17.png')
  },
  '0X0D': {
    type: 2,
    title: i18n.t('devicecard.energyconsumption'),
    src: require('../../assets/img/icon_type19.png')
  },
  '0X0E': {
    type: 2,
    title: i18n.t('devicecard.remaininglife'),
    src: require('../../assets/img/icon_type18.png')
  },
  '0X0F': {
    type: 2,
    title: i18n.t('devicecard.motortravel'),
    src: require('../../assets/img/icon_type16.png')
  },
  '0X10': {
    type: 2,
    title: i18n.t('devicecard.electricity'),
    src: require('../../assets/img/icon_type14.png')
  },
  '0X12': {
    type: 2,
    title: i18n.t('devicecard.motorangle'),
    src: require('../../assets/img/icon_type15.png')
  },
}